import type {ESPFormInputs, ESPStatusObj, EditESPFormInputs, ESPDeleteObj, DeleteESPResponse } from 'src/components/types/types';
import httpEmailAPI from '../common/http-email-api'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getESPConnectionData = async () => {
    const response = httpEmailAPI.get(`/espconnection/all`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const getESPConnectionDataById = async (id: any) => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const response = httpEmailAPI.get(`/espconnection/${id}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const addESPData = async (data: ESPFormInputs) => {
    const response = httpEmailAPI.post(`/espconnection/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const activatedeactivateESP = async (data: ESPStatusObj) => {
    const response = httpEmailAPI.patch(`/espconnection/activate`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateESPData = async (data: EditESPFormInputs) => {
    const response = httpEmailAPI.put(`/espconnection/update`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const deleteESP = async (data: ESPDeleteObj) => {
    const response = httpEmailAPI.delete<DeleteESPResponse>(`/espconnection/delete`, { data })
    return response;
}